import en from 'browser/translations/en';
import pl from 'browser/translations/pl';
import de from 'browser/translations/de';

export default {
  ...en,
  ...pl,
  ...de,
};
